import type { PriorityQueueItem } from './types';

export const PRIORITY_QUEUE: readonly PriorityQueueItem[] = [
  {
    memberId: 'raj-patel',
    reason: 'No Slack activity in 67 days. No events attended. Renewal in 7 months.',
    urgency: 'urgent',
    time: 'Now',
  },
  {
    memberId: 'jeffrey-wazen',
    reason: 'New member, relocating to Dallas with no local network. Revenue declining. Critical early window.',
    urgency: 'watch',
    time: 'Today',
  },
  {
    memberId: 'steve-brudzewski',
    reason: 'Mastermind survey not submitted. Only new member without one — blocks placement.',
    urgency: 'new',
    time: 'Today',
  },
  {
    memberId: 'michael-jamieson',
    reason: 'NDA never sent. Only member without one. Process gap.',
    urgency: 'watch',
    time: 'ASAP',
  },
  {
    memberId: 'derek-washington',
    reason: 'Engagement dropped 60% in last 30 days. Was active, now fading. No recent Slack.',
    urgency: 'watch',
    time: 'This week',
  },
] as const;
